import { PlusIcon } from "@heroicons/react/24/outline";

const AddButton = ({
  label,
  className,
  onClick,
  disabled,
}: {
  label: any;
  className?: string;
  onClick?: (e) => void;
  disabled?: boolean;
}) => (
  <button
    className={`bg-brand hover:ring-white/20 ring-4 ring-white/10 w-auto inline-flex whitespace-nowrap items-center pl-4 pr-6 border border-transparent shadow-md  howio-font-md rounded-full text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 ${className} `}
    onClick={onClick ? onClick : null}
    disabled={disabled}
  >
    {label}
  </button>
);

export default AddButton;
